// extracted by mini-css-extract-plugin
module.exports = {"rareSection":"rare_rareSection__vZUYI","rareH1":"rare_rareH1__2l39I","card":"rare_card__B5gTu","cardImage":"rare_cardImage__nuOtI","cardText":"rare_cardText__2xwVj"};